import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';

import allReducers from './reducers/index';

let countStarts = 0;
let countDones = 0;
let loadingStart = true;
const loaderMiddleware = store => next => action => {
  if (loadingStart) {
    loadingStart = false;
    store.dispatch({
      type: 'LOADING_STARTED',
      realAction: action.type,
    });
  }
  if (action.type.endsWith('START')) {
    countStarts++;
  }
  if (action.type.endsWith('DONE') || action.type.endsWith('ERROR')) {
    countDones++;
  }
  if (action.type !== 'LOADING_FINISHED' && countDones === countStarts) {
    store.dispatch({
      type: 'LOADING_FINISHED',
      realAction: action.type,
    });
    loadingStart = true;
  }
  next(action);
};

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  allReducers,
  composeEnhancers(applyMiddleware(thunkMiddleware, loaderMiddleware))
);

export default store;
